import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/CloseRounded';

class CloseIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default CloseIcon;
